









import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ErrorNotification from '@/components/shared/ErrorNotification.vue';
import { Cabinet, DocumentToStoreComponents, DocumentToStoreSearchModel } from '@/types';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';
import AxiosConfiguration from '@/classes/AxiosConfiguration';
import DefaultDocumentToStore from '@/components/documentToStore/DefaultDocumentToStore.vue';
import SelectExistingDocument from '@/components/documentToStore/SelectExistingDocument.vue';
import DocumentLock from '@/components/documentToStore/DocumentLock.vue';
export default Vue.extend({
  name: 'DocumentsToStore',
  data() {
    return {
      lastActivity: new Date()
    };
  },
  methods: {
    ...mapActions('documentToStoreStore', [
      'getDocumentToStore',
      'setComponentName',
      'setIsLoading',
      'releaseDocumentToStoreLock'
    ]),
    ...mapActions('documentViewStore', ['unloadDocument']),
    async initialise(this: any) {
      this.setIsLoading(true);
      const response = await AxiosConfiguration.axiosWithErrorPage.get(
        'parameter?entityTypeId=0&entityPk=0&group=DocumentsToStore&code=FeatureToggle'
      );
      const featureEnabled = (response.data as string).toLowerCase();
      if (featureEnabled !== 'true') {
        this.$router.push({
          name: 'errorPage',
          params: {
            errorCode: '401',
            errorMessage: 'Sorry, you do not have permission to access this page'
          }
        });
      }

      this.getDocumentToStore({
        sourceCabinetId: Cabinet.IncomingDocuments,
        sourceDocumentId: this.documentId
      } as DocumentToStoreSearchModel);
    },
    onExpiryModalButtonClicked(this: any) {
      this.$router.push({
        name: 'storeDocuments'
      });
    },
    userActivity(this: any) {
      this.lastActivity = new Date();
    },
    getComponentProps(this: any) {
      switch (this.componentName) {
        case 'SelectExistingDocument':
          return { storeNamespace: 'documentToStoreStore' };
        case 'ErrorNotification':
          return { errorModel: this.errorModel };
        default:
          return {};
      }
    }
  },
  computed: {
    ...mapGetters('documentToStoreStore', [
      'documentToStore',
      'isLoading',
      'componentName',
      'errorModel',
      'entityLock'
    ]),
    ...mapGetters('documentViewStore', ['document', 'deletedDocumentId']),
    documentId: {
      get(this: any) {
        return Number(this.$route.params.documentId);
      }
    },
    hasDocumentLock() {
      return !this.isLoading && this.entityLock && this.componentName !== DocumentToStoreComponents.Error;
    }
  },
  beforeDestroy(this: any) {
    this.unloadDocument();
    if (this.deletedDocumentId !== this.routeDocumentId) {
      this.releaseDocumentToStoreLock();
    }
    this.setComponentName(null);
  },
  mounted() {
    this.initialise();
  },
  created(this: any) {
    this.routeDocumentId = Number(this.$route.params.documentId);
  },
  components: {
    DefaultDocumentToStore,
    SelectExistingDocument,
    ErrorNotification,
    LoadingSpinner,
    DocumentLock
  }
});
